import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter, NavLink } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import Dropdown from 'react-bootstrap/Dropdown';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import axios from 'axios';
import {
    FaExternalLinkAlt, FaAndroid, FaApple, FaCog, FaPlus,
} from 'react-icons/fa';
import { FiExternalLink } from 'react-icons/fi';
import WorkspaceView from '@appblocks/frontend/client/Components/WorkspaceView';
import AppsDrawer from '@appblocks/frontend/client/Components/AppsDrawer';
import LoginButton from '@appblocks/frontend/client/Components/LoginButton';


const mapStateToProps = state => state;

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const { user, featureFlags } = this.props.user;
        return (
            <>
                <Navbar collapseOnSelect expand="lg" bg="light" variant="light" id="header" fixed="top" className="border-bottom">
                    <div className="container-fluid">
                        <Navbar.Brand as={Link} to="/">
                            <img
                                className="header-logo"
                                alt="Cody"
                                src="/static/img/app_blocks_logo.svg"
                            />
                            <span className="ms-2">
                                AppBlocks
                            </span>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="me-auto">
                                {user && (
                                    <Nav.Link as={NavLink} to="/apps" activeClassName="active">Applications</Nav.Link>
                                )}
                            </Nav>
                            <Nav>
                                <Nav.Link as={Link} to={{ pathname: `${process.env.HOME_URL}/tutorials` }} target="_blank">
                                    Tutorials&nbsp;
                                    <FiExternalLink className="nav-icon" />
                                </Nav.Link>
                                <Nav.Link as={Link} to={{ pathname: `${process.env.HOME_URL}/examples` }} target="_blank">
                                    Examples&nbsp;
                                    <FiExternalLink className="nav-icon" />
                                </Nav.Link>
                                <Nav.Link as={Link} to={{ pathname: `${process.env.HOME_URL}/docs/intro` }} target="_blank">
                                    Documentation&nbsp;
                                    <FiExternalLink className="nav-icon" />
                                </Nav.Link>
                                <Nav.Link as={Link} to={{ pathname: `${process.env.HOME_URL}/downloads` }} target="_blank">
                                    Downloads&nbsp;
                                    <FiExternalLink className="nav-icon" />
                                </Nav.Link>
                                <AppsDrawer variant="light" />
                                {user && (
                                    <WorkspaceView />
                                )}
                                <LoginButton />
                            </Nav>
                        </Navbar.Collapse>
                    </div>
                </Navbar>
            </>
        );
    }
}

export default connect(mapStateToProps, {})(
    Object.assign(withRouter(Header), { contextType: undefined }),
);
